import { createContext, useContext } from 'react';
import { ViewState } from 'react-map-gl';
import {
    initialFilters,
    initialMapView,
    initialReport,
    initialSettings,
    initialView,
} from './overwatch-2-initial-state';
import { Filters, Report, Settings, View } from './overwatch-2-types';

export type OverwatchContextType = {
    report: Report;
    filters: Filters;
    settings: Settings;
    view: View;
    mapView: ViewState;
};

export const OverwatchContext = createContext<OverwatchContextType>({
    report: initialReport,
    filters: initialFilters,
    settings: initialSettings,
    view: initialView,
    mapView: initialMapView,
});

export const useOverwatchContext = () => {
    if (!OverwatchContext) {
        throw new Error('useOverwatchContext must be used within a OverwatchContextProvider');
    }
    return useContext(OverwatchContext);
};
